{
    "poolsMicroserviceURL": "https://vuecapacityafd.azurefd.net/v1/",
    "capacityMicroserviceURL": "https://vuecapacityafd.azurefd.net/v1/",
    "pageTitleSuffix": ""
}